import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@mui/material'

const CdAccountEmployeeStatisticsTooltip = ({ data }) => {
  const classes = useStyles()
  return (
    <div className={classes.tooltipContent}>
      <Typography className={classes.tooltipText}>
        No. of Permanent Employees:
        <span className={classes.highlightText}>
          &nbsp;
          {data?.noOfPermanentEmployees ? data?.noOfPermanentEmployees : '---'}
        </span>
      </Typography>
      <Typography className={classes.tooltipText}>
        No. of Contract Employees:
        <span className={classes.highlightText}>
          &nbsp;
          {data?.noOfContractEmployees ? data?.noOfContractEmployees : '---'}
        </span>
      </Typography>
      <Typography className={classes.tooltipText}>
        Total No. of Employees:{' '}
        <span className={classes.highlightText}>
          &nbsp;
          {data?.noOfEmployeesCovered ? data?.noOfEmployeesCovered : '---'}
        </span>
      </Typography>
      <Typography className={classes.tooltipText}>
        No. of Lives Covered Avg:
        <span className={classes.highlightText}>
          &nbsp;{data?.noOfLivesCovered ? data?.noOfLivesCovered : '---'}
        </span>
      </Typography>
      <Typography className={classes.tooltipText}>
        Family size:
        <span className={classes.highlightText}>
          &nbsp;{data?.avgFamilySize ? data?.avgFamilySize : '---'}
        </span>
      </Typography>
      <Typography className={classes.tooltipFamilyText}>
        Definition of family:
        <span className={classes.highlightText}>
          &nbsp;{data?.definitionOfFamily ? data?.definitionOfFamily : '---'}
        </span>
      </Typography>
    </div>
  )
}

export default CdAccountEmployeeStatisticsTooltip
const useStyles = makeStyles({
  tooltipContent: {
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
  },
  tooltipText: {
    fontSize: '15px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'black',
    padding: '5px',
  },
  tooltipFamilyText: {
    fontSize: '15px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'black',
    marginTop: '10px',
    padding: '5px',
  },
  highlightText: {
    color: '#B92250',
    fontWeight: '500',
  },
})
